<template>
  <div class="crud_module--Select_weekday">
<!--    {{options[optionKey]}}-->
    <div class="text" v-if="action == 'View'">
        {{display_name()}}
    </div>
    <div class="text" v-else-if="action == 'List'">
        {{display_name()}}
    </div>
    <div v-else>
        <SelectionFrom
            :view="false"
            :value="value"
            :closeable="closeable"
            :filterable="filterable"
            :multiple="multiple"
            @input="selected"
            :option="selectKey"
            :setup="setup"
            :optionKey="optionKey"
        />
    </div>
    
  </div>
</template>

<script>
import SelectionFrom from '@/components/modules/SelectionFrom'

export default {
  components: {
    SelectionFrom,
  },
  props: ["data","k","field","action","options"],
  beforeMount() {
    this.col = this.field.key;
    if(this.field?.multiple != undefined){
      this.multiple = this.field?.multiple;
    }
    if(this.field?.closeable != undefined){
      this.closeable = this.field?.closeable;
    }
    if(this.field?.filterable != undefined){
      this.filterable = this.field?.filterable;
    }
    if(this.field?.setup != undefined){
      this.setup = this.field?.setup;
    }
    if (this.field?.optionKey){
      this.optionKey = this.field.optionKey;
    }

    if(this.data != undefined && this.data[this.col] != undefined){
        var arr = this.data[this.col].toString().split(',');
        this.value = this.selectKey.filter(row=>arr.includes(row[this.setup.value].toString()));
    }
  },
  methods: {
    selected(obj){
      var arr = [];
      console.log(obj)
      for(var i in obj){
        arr.push(obj[i][this.setup.value])
      }
      this.$emit("input", arr.join(','));
    },
    display_name(){
      var arr1 = [];
      try {
        var arr = this.data[this.col].toString().split(',');
        var da = this.selectKey.filter(row=>arr.includes(row[this.setup.value].toString()));
        for(var i in da){
          arr1.push(da[i][this.setup.label]);
        }
        
      } catch (error) {
        
      }
      return arr1.join(',')
    }
  },
  computed:{
    selectKey(){
      var _this = this;

      if (!this.field?.option){
        return this.options[this.optionKey];
      }else{
        return this.field.option.map(r=>{
          r.name = _this.$t(r.name);
          return r;
        });
      }

    }
  },
  data() {
    return {
      multiple:true,
      filterable:false,
      closeable:true,
      value:undefined,
      col:"",
      setup:{label:'name',value:'id'},
      optionKey:""
    }
  }
}
</script>

<style lang="scss">
.crud_module--Select_weekday{
  width: 100%;
}
</style>